import { gql } from "@apollo/client";

// AUTH
export const SIGNUP_MUTATION = gql`
  mutation SignUp(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $password: String!
    $lat: Float!
    $long: Float!
    $country: String!
    $favouriteCategories: [String!]!
    $referralCode: String
  ) {
    signUp(
      signUpInput: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
        password: $password
        lat: $lat
        long: $long
        country: $country
        favouriteCategories: $favouriteCategories
        referralCode: $referralCode
      }
    )
  }
`;

export const SIGNIN_SOCIAL = gql`
  mutation loginSocial(
    $accessToken: String!
    $socialAuthProviderKey: String!
    $useAccessToken: Boolean!
  ) {
    loginThroughSocialAuth(
      payload: {
        accessToken: $accessToken
        socialAuthProviderKey: $socialAuthProviderKey
        useAccessToken: $useAccessToken
      }
    )
  }
`;

export const SIGNUP_SOCIAL = gql`
  mutation signupSocial(
    $accessToken: String!
    $socialAuthProviderKey: String!
    $useAccessToken: Boolean!
    $country: String!
  ) {
    registerThroughSocialAuth(
      payload: {
        accessToken: $accessToken
        socialAuthProviderKey: $socialAuthProviderKey
        country: $country
        lat: 0.002222
        long: 0.002222
        useAccessToken: $useAccessToken
        favouriteCategories: []
      }
    )
  }
`;

export const RESEND_OTP = gql`
  mutation ResendOTP($email: String!) {
    resendOTP(emailInput: { email: $email })
  }
`;

export const DECLINE_APPOINTMENT = gql`
  mutation DeclineAppointment($appointmentId: String!) {
    declineAppointment(payload: { appointmentId: $appointmentId }) {
      message
    }
  }
`;

export const ACCEPT_APPOINTMENT = gql`
  mutation AcceptAppointment($appointmentId: String!) {
    acceptAppointment(payload: { appointmentId: $appointmentId }) {
      message
    }
  }
`;

export const RESCHEDULE_APPOINTMENT = gql`
  mutation RescheduleAppointmentBySeller(
    $appointmentId: String!
    $scheduledDate: String!
    $scheduledTime: String!
  ) {
    rescheduleAppointmentBySeller(
      payload: {
        appointmentId: $appointmentId
        scheduledDate: $scheduledDate
        scheduledTime: $scheduledTime
      }
    ) {
      message
    }
  }
`;

export const BOOK_APPOINTMENT = gql`
  mutation StartAppointmentByBuyer(
    $serviceId: String!
    $scheduledDate: String!
    $scheduledTime: String!
  ) {
    startAppointmentByBuyer(
      payload: {
        serviceId: $serviceId
        scheduledDate: $scheduledDate
        scheduledTime: $scheduledTime
      }
    ) {
      createdAt
      updatedAt
      _id
      reference
      offerAmount
      totalPrice
      scheduledDate
      scheduledTime
      status
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation reset($otp: String!, $uuid: String!, $password: String!) {
    resetPasswordWithOTP(
      passwordResetInput: { otp: $otp, uuid: $uuid, password: $password }
    )
  }
`;

export const VALIDATE_OTP = gql`
  mutation ValidateOTP($uuid: String!, $otp: String!) {
    validateOTP(validateOtpInput: { uuid: $uuid, otp: $otp })
  }
`;

export const CREATE_PIN = gql`
  mutation CreateTransactionPin($userId: String!, $transactionPin: String!) {
    createTransactionPinOnSignUp(
      createTransactionPinInput: {
        userId: $userId
        transactionPin: $transactionPin
      }
    )
  }
`;

export const CREATE_STORE = gql`
  mutation CreateStore(
    $storeName: String!
    $registeredNumber: String
    $employerIdentificationNumber: String
    $address: String!
    $storeLogo: String
    $storeBannerUrl: String
    $storeDescription: String
    $categoriesToSell: [String!]
    $planId: String!
  ) {
    createStore(
      input: {
        storeName: $storeName
        registeredNumber: $registeredNumber
        employerIdentificationNumber: $employerIdentificationNumber
        address: $address
        storeLogo: $storeLogo
        storeBannerUrl: $storeBannerUrl
        storeDescription: $storeDescription
        categoriesToSell: $categoriesToSell
        planId: $planId
      }
    ) {
      _id
      uuid
      firstName
      lastName
      email
      phone
      role
      hasStore
      hasRegistered
      hasCompletedSellerVerification
      profileStatus
      activityStatus
    }
  }
`;

export const UPDATE_STORE = gql`
  mutation UpdateStore(
    $storeName: String!
    $registeredNumber: String
    $employerIdentificationNumber: String
    $address: String!
    $storeLogo: String
    $storeBannerUrl: String
    $storeDescription: String
    $categoriesToSell: [String!]
  ) {
    updateStore(
      input: {
        storeName: $storeName
        registeredNumber: $registeredNumber
        employerIdentificationNumber: $employerIdentificationNumber
        address: $address
        storeLogo: $storeLogo
        storeBannerUrl: $storeBannerUrl
        storeDescription: $storeDescription
        categoriesToSell: $categoriesToSell
      }
    ) {
      _id
      uuid
      firstName
      lastName
      email
      phone
      role
      hasStore
      store
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(loginPayload: { email: $email, password: $password })
  }
`;
// .....................................................

// DASHBOARD

export const PROFILE_EDIT = gql`
  mutation updateProfileInformation(
    $sex: String
    $dateOfBirth: String
    $firstName: String
    $lastName: String
    $country: String!
    $favouriteCategories: [String!]
    $imageUrl: String
  ) {
    updateProfileInformation(
      payload: {
        sex: $sex
        dateOfBirth: $dateOfBirth
        firstName: $firstName
        lastName: $lastName
        country: $country
        favouriteCategories: $favouriteCategories
        imageUrl: $imageUrl
      }
    ) {
      createdAt
      updatedAt
      _id
      uuid
      firstName
      lastName
      role
      imageUrl
      email
      phone
      sex
      dateOfBirth
      referralCode
      isDeleted
      previousEmail
      previousPhone
      verifiedAt
      profileStatus
      activityStatus
      coordinates
      registrationSource
      hasPaidMembershipFee
      hasRegistered
      hasCompletedSellerVerification
      stripeAccountId
      referred
      isPhoneNumberVerified
      store
      hasStore
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(
      payload: { currentPassword: $currentPassword, newPassword: $newPassword }
    ) {
      firstName
      lastName
    }
  }
`;

export const CHANGE_PIN = gql`
  mutation changeTransactionPin(
    $currentPassword: String!
    $currentTransactionPin: String!
    $newTransactionPin: String!
  ) {
    changeTransactionPin(
      payload: {
        currentPassword: $currentPassword
        currentTransactionPin: $currentTransactionPin
        newTransactionPin: $newTransactionPin
      }
    ) {
      firstName
      lastName
    }
  }
`;

export const ADD_ADDRESS = gql`
  mutation addNewAddress(
    $firstName: String!
    $lastName: String!
    $country: String!
    $state: String!
    $city: String!
    $addressOne: String!
    $addressTwo: String
    $zipCode: String!
    $phone: String!
    $isDefault: Boolean!
  ) {
    addNewAddress(
      payload: {
        firstName: $firstName
        lastName: $lastName
        country: $country
        state: $state
        city: $city
        addressOne: $addressOne
        addressTwo: $addressTwo
        zipCode: $zipCode
        phone: $phone
        isDefault: $isDefault
      }
    )
  }
`;

export const ADD_SHIPPING_ADDRESS = gql`
  mutation AddNewShippingAddress(
    $firstName: String!
    $lastName: String!
    $state: String!
    $city: String!
    $addressOne: String!
    $addressTwo: String
    $zipCode: String!
    $phone: String!
    $isDefault: Boolean!
  ) {
    addNewShippingAddress(
      payload: {
        firstName: $firstName
        lastName: $lastName
        state: $state
        city: $city
        addressOne: $addressOne
        addressTwo: $addressTwo
        zipCode: $zipCode
        phone: $phone
        isDefault: $isDefault
      }
    )
  }
`;

export const EDIT_ADDRESS = gql`
  mutation addNewAddress(
    $firstName: String!
    $lastName: String!
    $country: String!
    $state: String!
    $city: String!
    $addressOne: String!
    $addressTwo: String
    $zipCode: String!
    $addressId: String!
    $phone: String!
    $isDefault: Boolean!
  ) {
    updateAddress(
      payload: {
        firstName: $firstName
        lastName: $lastName
        country: $country
        state: $state
        city: $city
        addressOne: $addressOne
        addressTwo: $addressTwo
        zipCode: $zipCode
        addressId: $addressId
        phone: $phone
        isDefault: $isDefault
      }
    )
  }
`;

export const ADD_FUNDS = gql`
  mutation initializeWalletFunding($amount: Float!) {
    initializeWalletFunding(
      payload: { amount: $amount, gatewayProviderClass: "stripe.service" }
    )
  }
`;

export const UPGRADE_SUBSCRIPTION_PLAN = gql`
  mutation UpgradeSubscriptionPlan($planId: String!) {
    upgradeSubscriptionPlan(input: { planId: $planId }) {
      createdAt
      updatedAt
      _id
      status
      startDate
      endDate
      autoRenew
    }
  }
`;
// .................................................

// CHECKOUT
export const CREATE_ORDER = gql`
  mutation createOrder(
    $deliveryOption: String!
    $transactionPin: String!
    $shippingAddressId: String
    $shippoRateSelections: JSON
  ) {
    createOrder(
      payload: {
        deliveryOption: $deliveryOption
        transactionPin: $transactionPin
        shippingAddressId: $shippingAddressId
        shippoRateSelections: $shippoRateSelections
      }
    )
  }
`;

export const SERVICE_CHECKOUT = gql`
  mutation {
    checkoutMyCartItems {
      message
    }
  }
`;

export const ADD_CARTS = gql`
  mutation addToCart($product: String!, $quantity: Float!) {
    addToCart(payload: { product: $product, quantity: $quantity }) {
      _id
      quantity
      pricePerUnit
      totalAmount
      createdAt
      updatedAt
      product {
        _id
        name
        description
        images
      }
      session {
        _id
        currency {
          name
          shortCode
          shortCode
        }
      }
    }
  }
`;

export const REMOVE_CARTS = gql`
  mutation removeItems($itemIds: String!) {
    removeItems(payload: { itemIds: [$itemIds] })
  }
`;

export const CANCEL_ORDER = gql`
  mutation cancelProduct(
    $itemId: String!
    $reason: String!
    $description: String!
  ) {
    cancelProductOrderByBuyer(
      payload: { itemId: $itemId, reason: $reason, description: $description }
    ) {
      message
    }
  }
`;

export const GET_MY_CART_SUMMARY = gql`
  query GetMyCartSummary(
    $deliveryOption: String!
    $shippingAddressId: String
    $shippoRateSelections: JSON
  ) {
    getMyCartSummary(
      payload: {
        deliveryOption: $deliveryOption
        shippingAddressId: $shippingAddressId
        shippoRateSelections: $shippoRateSelections
      }
    ) {
      itemPrice
      serviceFee
      taxFee
      shippingFee
      subTotal
      shippoRateOptions
    }
  }
`;

export const RELEASE_FUNDS = gql`
  mutation releaseFunds($itemId: String!, $rating: Float!, $comments: String!) {
    confirmIndividualProductOrderByTheBuyer(
      payload: { itemId: $itemId, rating: $rating, comments: $comments }
    ) {
      message
    }
  }
`;

export const SERVICE_RELEASE_FUNDS = gql`
  mutation orderId($appointmentId: String!) {
    triggerReleaseFundByBuyerAfterCompletion(
      payload: { appointmentId: $appointmentId }
    ) {
      message
    }
  }
`;

export const SUBSCRIBE = gql`
  mutation subscribe($email: String!) {
    subscribeToNewsLetter(payload: { email: $email }) {
      message
    }
  }
`;

export const CONTACT_US = gql`
  mutation sendContact($fullName: String!, $email: String!, $message: String!) {
    sendContactUsMessage(
      payload: { fullName: $fullName, email: $email, message: $message }
    ) {
      message
    }
  }
`;

export const DISPUTE_ORDER = gql`
  mutation ($files: [Upload!], $payload: DisputeOrderDto!) {
    submitDispute(files: $files, payload: $payload) {
      message
    }
  }
`;

export const CHANGE_PHONE = gql`
  mutation changePhone($country: String!, $phone: String!) {
    requestToChangePhoneNumber(payload: { country: $country, phone: $phone }) {
      message
      userId
      otp # This would be removed. Only available at the time of development
    }
  }
`;

export const EDIT_PHONE_OTP = gql`
  mutation confirmOtp($otp: String!) {
    handlePhoneNumberChangeRequest(payload: { otp: $otp }) {
      message
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation update($notification: [String!]!) {
    updateMyNotificationPreferences(
      configDto: { notifications: $notification }
    ) {
      notifications {
        _id
        title
      }
    }
  }
`;

export const ADD_FAVOURITE = gql`
  mutation addFav($productOrServiceId: String!, $isProduct: Boolean!) {
    addFavourite(
      payload: {
        productOrServiceId: $productOrServiceId
        isProduct: $isProduct
      }
    ) {
      _id
      isProduct
      productOrService
      createdAt
      updatedAt
    }
  }
`;

export const ADD_TO_WAITLIST = gql`
  mutation AddToWaitlist(
    $zipCode: String!
    $Interested: String!
    $description: String!
    $country: String!
    $categories: [String!]!
    $email: String!
    $currentSpend: String!
    $preferredSpend: String!
  ) {
    addToWaitlist(
      payload: {
        zipCode: $zipCode
        Interested: $Interested
        description: $description
        country: $country
        categories: $categories
        email: $email
        currentSpend: $currentSpend
        preferredSpend: $preferredSpend
      }
    )
  }
`;

export const ADD_TO_ACTIVELIST = gql`
  mutation AddToActivelist($zipCode: String!) {
    addToActivelist(payload: { zipCode: $zipCode })
  }
`;

export const DELETE_FAV = gql`
  mutation delete($userFavouriteId: String!) {
    deleteFavourite(payload: { userFavouriteId: $userFavouriteId }) {
      message
    }
  }
`;

export const DELETE_SERVICE = gql`
  mutation DeleteMyService($serviceId: String!) {
    deleteMyService(payload: { serviceId: $serviceId })
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation DeleteProfile {
    deleteProfile {
      message
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation ($files: [Upload!]!, $payload: CreateProductDto!) {
    createProduct(files: $files, payload: $payload)
  }
`;
export const CREATE_PRODUCTV2 = gql`
  mutation CreateProductV2( $payload: CreateProductV2Dto!) {
    createProductV2( payload: $payload)
  }
`;

export const CREATE_PRODUCT_V3 = gql`
  mutation CreateProductV3($payload: CreateProductV3Dto!) {
    createProductV3(payload: $payload)
  }
`;

export const EDIT_PRODUCT_V3 = gql`
  mutation EditProductV3($payload: EditProductV3Dto!) {
    editProductV3(payload: $payload)
  }
`;

export const CREATE_SERVICE = gql`
  mutation ($file: Upload!, $payload: CreateUserServiceDto!) {
    creatService(file: $file, payload: $payload) {
      reference
      createdAt
      updatedAt
      images
      title
      description
      price
      rateType
      status
    }
  }
`;

export const EDIT_PRODUCT = gql`
  mutation EditProduct($payload: EditProductDto!) {
    editProduct(payload: $payload)
  }
`;

export const EDIT_SERVICE = gql`
  mutation EditService(
    $serviceId: String!
    $title: String!
    $category: String!
    $description: String!
    $price: Float!
    $isNegotiable: Boolean!
    $city: String!
  ) {
    editService(
      payload: {
        serviceId: $serviceId
        title: $title
        category: $category
        description: $description
        price: $price
        isNegotiable: $isNegotiable
        city: $city
      }
    ) {
      _id
      reference
      title
      description
      price
      rateType
      status
      isNegotiable
      images
      createdAt
      updatedAt
      city {
        name
        state {
          name
          country {
            name
            currency {
              name
              symbol
              alias
            }
          }
        }
      }
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation delete($productId: String!) {
    deleteProduct(payload: { productId: $productId })
  }
`;

export const STOCK_UP_PRODUCT = gql`
  mutation StockUpProduct($productId: String!, $quantity: Int!) {
    stockUpProduct(payload: { productId: $productId, quantity: $quantity })
  }
`;

export const PROCESS_ORDER = gql`
  mutation changeOrder($orderIds: String!) {
    changeOrderToProcessing(payload: { orderIds: [$orderIds] }) {
      message
    }
  }
`;

export const ORDER_SHIPPED = gql`
  mutation changeOrderShip($orderIds: String!) {
    changeOrderToShipped(payload: { orderIds: [$orderIds] }) {
      message
    }
  }
`;

export const ORDER_DELIVERED = gql`
  mutation changeOrderDel($orderIds: String!) {
    changeOrderToDelivered(payload: { orderIds: [$orderIds] }) {
      message
    }
  }
`;

export const PAY_VERIFICATION = gql`
  mutation {
    payToBecomeASeller {
      message
    }
  }
`;

export const WAIVE_PAYMENT = gql`
  mutation WaivePayToBecomeASeller {
    waivePayToBecomeASeller {
      message
    }
  }
`;

export const EDIT_PRODUCT_IMAGE = gql`
  mutation AddMoreImagesToProduct($files: [Upload!]!, $serviceId: String!) {
    addMoreImagesToProduct(files: $files, productId: $productId)
  }
`;
export const EDIT_SERVICE_IMAGE = gql`
  mutation addMoreServiceImages($files: [Upload!]!, $serviceId: String!) {
    addMoreServiceImages(files: $files, serviceId: $serviceId)
  }
`;

export const DELETE_EXISTING_IMAGE = gql`
  mutation RemoveImagesFromProduct($productId: String!, $images: [String!]!) {
    removeImagesFromProduct(payload: { productId: $productId, images: $images })
  }
`;
export const DELETE_SERVICE_IMAGE = gql`
  mutation deleteServiceImages($serviceId: String!, $images: [String!]!) {
    deleteServiceImages(payload: { serviceId: $serviceId, images: $images })
  }
`;

export const START_APPOINTMENT = gql`
  mutation start($appointmentId: String!) {
    startAppointmentBySeller(payload: { appointmentId: $appointmentId }) {
      message
    }
  }
`;

export const COMPLETE_APPOINTMENT = gql`
  mutation start($appointmentId: String!) {
    triggerAppointmentCompletionBySeller(
      payload: { appointmentId: $appointmentId }
    ) {
      message
    }
  }
`;

export const ADD_ACCOUNT = gql`
  mutation add(
    $bankName: String!
    $accountName: String!
    $accountNumber: String!
    $routingNumber: String!
  ) {
    addNewBank(
      payload: {
        bankName: $bankName
        accountHolderType: "individual"
        accountName: $accountName
        accountNumber: $accountNumber
        routingNumber: $routingNumber
      }
    ) {
      _id
      accountName
      accountNumber
      routingNumber
      bankName
      createdAt
      updatedAt
    }
  }
`;

export const WITHDRAWAL_REQUEST = gql`
  mutation withdraw($bankId: String!, $amount: Float!) {
    sendWithdrawalRequest(payload: { bankId: $bankId, amount: $amount }) {
      _id
      reference
      amount
      remarks
      provider
      status
      createdAt
      updatedAt
      currency
    }
  }
`;
